module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/logo_maestro.0e3ebe42.png";